
import { Component, Inject, Input, OnDestroy, OnInit, Renderer2, DOCUMENT } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TYPE_SERVICES } from 'app/core/models/constans.model';
import { AnalyticsService } from 'app/core/services/analytics.service';
import { Menu } from 'app/menu/models/menu.model';
import { CREATE_FIELDS_RATE_EN, CREATE_FIELDS_RATE_ES } from 'app/menu/models/newsletter.model';
import { Restaurant } from 'app/menu/models/restaurants.model';
import { CreateDialogComponent } from '../create-dialog/create-dialog.component';
import { MenuService } from './../../../menu/services/menu.service';

/**
 * Componente pie de pagina
 */
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
  /**
   * Informacion del menu del rest
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Informacion del restaurante
   */
  @Input() restaurant: Restaurant = {} as Restaurant;
  /**
   * Indica si se debe colocar la direccion
   */
  @Input() address = false;
  /**
   * Indica si se debe de visualizar
   * el boton de formulario de calificacion
   */
  @Input() showForm = false;
  /**
   * Link para navegar a la cuenta de instagram
   */
  link = '';
  /**
   * Link para navegar a la cuenta de whatsapp
   */
  linkWs = '';
  /**
   * Cuando no se tiene color de background se coloca
   * el negro como color por defecto de los iconos de redes sociales
   */
  colorText = '#090909';

  /**
   * Indica si se debe de ver el boton de home
   */
  viewHome: boolean | undefined;
  /**
   * Indica si es modulo menu
   */
  isModuleMenu = true;
  /**
   * Idioma seleccionado
   */
  language = 'ES';
  /**
   * Indica si se debe de ver la aalerta de calificacion enviada
   */
  showAlert = false;
  /**
   * Constructor
   */
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private menuService: MenuService,
    private activateRoute: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private dialog: MatDialog,
    private renderer: Renderer2,
  ) {
    this.menuService.getHome().subscribe((v: boolean) => {
      this.viewHome = v;
    });
    this.menuService.getLang().subscribe((lan: string) => {
      this.language = lan;
    });
    this.renderer.addClass(this.document.body, 'embedded-body');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'embedded-body');
  }

  /**
   * Establece los links de navegacion
   */
  ngOnInit(): void {
    this.setLinks();
    setTimeout(() => {
      if (this.restaurant.services === TYPE_SERVICES.roomService) {
        this.isModuleMenu = false;
      }
      this.setColors();
    }, 1000);
  }

  /**
   * Indica que se debe de ver el home
   */
  goHome(): void {
    const isDetail = this.router.url.indexOf('menu-detail');
    if (isDetail !== -1) {
      this.menuService.setHome(true);
      this.router.navigateByUrl(`menu/${this.activateRoute.snapshot.params.id}`);
    } else {
      this.menuService.setHome(true);
    }
  }

  /**
   * Abre el dialogo con el formulario e inserta la info en BD
   */
  openForm(): void {
    const form = this.language === 'ES' ? CREATE_FIELDS_RATE_ES : CREATE_FIELDS_RATE_EN;
    const dialogRef = this.dialog.open(CreateDialogComponent, {
      data: {
        fields: form, title: this.language === 'ES' ? 'Califícanos' : 'Rate us',
        button: { action: this.language === 'ES' ? 'Enviar' : 'Send', visible: true }, col: 'col-12'
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const body = {
          ...result,
          idClient: this.restaurant.idClient,
          restaurant_id: this.restaurant.id
        };
        this.analyticsService.sendRateInfo(body).then((r) => {
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 2000);
        });
      }
    });
  }

  /**
   * Envia el evento de analytics cuando se selecciona
   * alguna de las redes sociales
   *
   * @param type red social seleccionada
   */
  clickLink(type: string): void {
    const info = {
      restaurant_id: this.restaurant.id,
      social_media: type,
      product_id: '',
      type: 'product_click',
    };
    switch (type) {
      case 'i':
        info.type = 'instagram_click';
        if (this.restaurant.metrics) {
          this.analyticsService.sendAnalyticsInfo(info.type, info);
        }
        break;
      case 'g':
        info.type = 'google_click';
        if (this.restaurant.metrics) {
          this.analyticsService.sendAnalyticsInfo(info.type, info);
        } break;
      case 'w':
        info.type = 'whatsapp_click';
        if (this.restaurant.metrics) {
          this.analyticsService.sendAnalyticsInfo(info.type, info);
        } break;
      case 't':
        info.type = 'tripadvisor_click';
        if (this.restaurant.metrics) {
          this.analyticsService.sendAnalyticsInfo(info.type, info);
        } break;
      default:
        break;
    }
  }


  /**
   * Establece los links de redes sociales
   */
  private setLinks(): void {
    if (this.restaurant.instagram !== '') {
      this.link = `https://www.instagram.com/${this.restaurant.instagram}/`;
    }
    if (this.restaurant.phone !== '') {
      this.linkWs = `https://api.whatsapp.com/send?phone=${this.restaurant.phone}`;
    }
  }
  /**
   * Establece los colores
   */
  private setColors(): void {
    if (this.router.url.includes('menu-detail')) {
      this.colorText = this.menu.colorText;
      return;
    }
    this.colorText = this.restaurant.colorText ? this.restaurant.colorText : this.colorText;
    if (this.restaurant.color) {
      if (this.restaurant.color === '#000000') {
        this.colorText = '#FFFFFF';
      } else if (!this.restaurant.colorText) {
        this.colorText = this.hexToLighterColor(this.restaurant.color).toString();
      }
    }

  }

  /**
   * Convierte un color hexadecimal en el
   * color opuesto en rgb
   *
   * @param hex color en hexadecimal
   * @returns color en rgb
   */
  private hexToLighterColor(hex: string, factor: number = 0.4): string {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
      return '#ffffff';
    }

    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);

    // Convertir RGB a HSL
    const [h, s, l] = this.rgbToHsl(r, g, b);

    // Aumentar lightness según el factor (ej: +40%)
    const newL = Math.min(1, l + factor);

    // Convertir de nuevo a RGB
    const [newR, newG, newB] = this.hslToRgb(h, s, newL);

    return `rgb(${Math.round(newR)}, ${Math.round(newG)}, ${Math.round(newB)})`;
  }

  private rgbToHsl(r: number, g: number, b: number): [number, number, number] {
    r /= 255;
    g /= 255;
    b /= 255;

    const max = Math.max(r, g, b); const min = Math.min(r, g, b);
    let h = 0; let s = 0; const l = (max + min) / 2;

    if (max !== min) {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case r: h = ((g - b) / d + (g < b ? 6 : 0)); break;
        case g: h = ((b - r) / d + 2); break;
        case b: h = ((r - g) / d + 4); break;
      }

      h /= 6;
    }

    return [h, s, l];
  }

  private hslToRgb(h: number, s: number, l: number): [number, number, number] {
    let r: number; let g: number; let b: number;

    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      const hue2rgb = (p: number, q: number, t: number) => {
        if (t < 0) {
          t += 1;
        }
        if (t > 1) {
          t -= 1;
        }
        if (t < 1 / 6) {
          return p + (q - p) * 6 * t;
        }
        if (t < 1 / 2) {
          return q;
        }
        if (t < 2 / 3) {
          return p + (q - p) * (2 / 3 - t) * 6;
        }
        return p;
      };

      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;

      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [r * 255, g * 255, b * 255];
  }

}
